import { useSignal, useComputed$, useTask$ } from "@builder.io/qwik";
function useCombinedRef(externalRef, ctxOpts) {
  const internalRef = useSignal();
  const ctxRefNameSig = useComputed$(() => {
    if (!ctxOpts?.context || !ctxOpts?.givenContextRef)
      return;
    for (const key in ctxOpts.context) {
      if (ctxOpts.context[key] === ctxOpts.givenContextRef) {
        return key;
      }
    }
    return void 0;
  });
  const contextRefExists = ctxRefNameSig.value !== void 0;
  const contextRef = contextRefExists && ctxOpts?.context?.[ctxRefNameSig.value];
  useTask$(() => {
    if (!externalRef)
      return;
    if (contextRef) {
      ctxOpts.context[ctxRefNameSig.value] = externalRef;
    } else {
      internalRef.value = externalRef.value;
    }
  });
  const mergedRef = contextRef ? contextRef : internalRef;
  if (!mergedRef) {
    throw new Error("Qwik UI: useCombinedRef could not find the ref. Please pass a ref to the component.");
  }
  return mergedRef;
}
export {
  useCombinedRef
};
